import { Box, Typography, Tooltip } from "@mui/material";
// config
import colors from "../../../config/colors";
// utils
import { formatNumberKMB, getAssetUrl } from "../../../utils/helpers";
import {
  ACTION,
  CATEGORY,
  LABEL2,
  PAGE,
  SCREEN,
  triggerGa,
} from "../../../utils/gaUtils";

const CreatorSubDetails = ({ item }) => {
  const instaFollowers = item?.insta_followers || 0;
  const ytSubscribers = item?.yt_subscribers || 0;
  const gender =
    item?.gender === "M" ? "Male" : item?.gender === "F" ? "Female" : "Unisex";
  const handleInstaClick = (e) => {
    triggerGa({
      category: CATEGORY.USER_INTERACTION,
      action: ACTION.INSTA_CLICK,
      label: item?.username,
      label3: LABEL2.PROFILE_INTEREST,
      page: PAGE.CREATOR_DISCOVER,
      screenName: SCREEN.CREATOR_DRAWER,
    });
    e.stopPropagation();
    window.open(`${item?.profile_link}`, "_blank");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 1,
        minWidth: 0,
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
      {instaFollowers > 0 && (
        <Tooltip title={instaFollowers.toLocaleString()} placement="top">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              minWidth: 0,
              cursor: "pointer",
            }}
            onClick={handleInstaClick}
          >
            <img
              src={getAssetUrl("Instagram_icon.png")}
              alt="Instagram"
              style={{
                width: 20,
                height: 20,
                flexShrink: 0,
              }}
            />
            <Typography
              fontSize={12}
              fontWeight={500}
              lineHeight="16px"
              noWrap
              sx={{
                minWidth: 0,
                flex: 1,
              }}
            >
              {formatNumberKMB(instaFollowers)}
            </Typography>
          </Box>
        </Tooltip>
      )}
      <Typography
        fontSize={12}
        fontWeight={500}
        lineHeight="16px"
        color={colors.gray600}
      >
        |
      </Typography>

      <Typography
        fontSize={12}
        fontWeight={400}
        lineHeight="16px"
        color={colors.gray600}
      >
        {gender}
      </Typography>
      {/* <Typography
        fontSize={12}
        fontWeight={500}
        lineHeight="16px"
        color={colors.gray600}
      >
        |
      </Typography> */}

      {/* {ytSubscribers > 0 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            minWidth: 0,
          }}
        >
          <YouTubeIcon
            sx={{
              width: 20,
              height: 20,
              flexShrink: 0,
              color: colors.gray200,
            }}
          />
          <Typography
            fontSize={12}
            noWrap
            sx={{
              minWidth: 0,
              flex: 1,
            }}
          >
            {formatNumberKMB(ytSubscribers)}
          </Typography>
        </Box>
      )} */}

      {instaFollowers === 0 && (
        <Typography fontSize={12} color={colors.gray200}>
          No followers
        </Typography>
      )}
    </Box>
  );
};

export default CreatorSubDetails;
